















import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { localize } from '../../filters/localize';
import { UserHelper } from '@/helper/user';
import Vue from 'vue';
import Price from '../price/Price.vue';

@Component
export default class DepositPartInfoToolTip extends Mixins(BaseMixin) {
    @Prop(Number)
    private priceNetCents!: number;
    @Prop(Number)
    private priceGrossCents!: number;
    @Prop(Number)
    private priceDiscountedNetCents!: number;

    private priceHtml?: string;

    // called by vue
    public created(): void {
        const ComponentClass = Vue.extend(Price);
        const instance = new ComponentClass({
            propsData: {
                priceNetCents: this.priceNetCents,
                priceGrossCents: this.priceGrossCents,
                priceDiscountedNetCents: this.priceDiscountedNetCents,
                rightAligned: true,
                noWrap: true,
            },
        });
        instance.$mount();
        this.priceHtml = instance.$el.outerHTML;
    }

    private get toolTipMessage(): string {
        if (!this.priceHtml) {
            return '';
        }

        return `<b>${localize(this.l10n.DEPOSIT_PART_INFO_TOOLTIP.INFO_TEXT)}</b>:<br/>${this.priceHtml}`;
    }
}
